import { DocumentTypeEnum } from 'features/declaration/models/schemas/documentSchemas'
import { sortBySequenceNumber } from 'shared/lib/common-util'
import {
  Document,
  DocumentFile,
  TransportDocument,
} from './types'
import { DocumentResponse, FileResponse } from '../../../../api/models'
import { toIntOrNull, toNonNegativeIntOrNull } from '../../../../helpers'

export function fromFileResponse(fileResponse: FileResponse, documentId: number): DocumentFile {
  return {
    id: fileResponse.id,
    fileName: fileResponse.filename,
    mimeType: fileResponse.mimeType,
    sequenceNumber: fileResponse.sortOrder,
    deleted: false,
    uuid: fileResponse.uuid,
    file: null,
    fileBlob: null,
    url: null,
    documentId,
  }
}

export function fromDocumentResponse(response: DocumentResponse, index: number): Document {
  const type = DocumentTypeEnum.parse(response?.type?.toString() ?? 'TRANSPORT')

  const baseDocument = {
    id: response.id,
    type,
    sequenceNumber: response.sequenceNumber ?? index,
    documentType: response.documentType ?? '',
    referenceNumber: response.referenceNumber ?? '',
    files: response.files
      .map((fileResponse) => fromFileResponse(fileResponse, response.id as number))
      .sort(sortBySequenceNumber),
    deleted: false,
  }

  switch (type) {
    case 'PREVIOUS':
      return {
        ...baseDocument,
        type,
        complementOfInformation: response.complementOfInformation ?? '',
        transportDocumentReferenceNumber: response.transportDocumentReferenceNumber ?? '',
        procedureType: response.procedureType ?? '',
      }
    case 'SUPPORTING':
      return {
        ...baseDocument,
        type,
        complementOfInformation: response.complementOfInformation ?? '',
        documentLineNumber: toNonNegativeIntOrNull(response.documentLineItemNumber),
      }
    case 'NOTE':
      return {
        ...baseDocument,
        type,
        complementOfInformation: response.complementOfInformation ?? '',
        transitOperationId: toIntOrNull(response.transitOperationId),
      }
    default:
      return baseDocument as TransportDocument
  }
}
